import { JSX } from 'react'

import { spinnerVariants } from '~/components/component-library/LoadingSpinner/styles'
import { type LoadingSpinnerProps } from '~/components/component-library/LoadingSpinner/types'
import { cn } from '~/utils/tailwind-utils'

export { type LoadingSpinnerProps } from '~/components/component-library/LoadingSpinner/types'

export const LoadingSpinner = ({
  size,
  thickness,
  variant,
}: LoadingSpinnerProps): JSX.Element => {
  return (
    <div>
      <div
        style={{ borderTopColor: 'transparent' }}
        className={cn(spinnerVariants({ size, thickness, variant }))}
      />
    </div>
  )
}
